import { BehaviorSubject } from "rxjs";
import {isEqual} from 'lodash';
import Api from '../api/Api';
import {getQuerySubscriptions, normalizeSubscriptions} from '../helpers/normalizeResults';
import NotificationsStore from './notifications';

const SubscriptionsStore = {
  current$: new BehaviorSubject<Array<any>>([]),
  normalized$: new BehaviorSubject({}),
  querySubscriptions$: new BehaviorSubject<Array<any>>([]),
  connectionLinks$: new BehaviorSubject([]),
  loading$: new BehaviorSubject(false),
  error$: new BehaviorSubject<null | any>(null),
  lastFetch: null,
  pollInterval: null as any,
  async getUserSubscriptions(force?:boolean) {
    if (!force && this.lastFetch) {
      const now = new Date();
      // @ts-ignore
      const diff = now.getTime() - this.lastFetch.getTime();
      // don't fetch new subscriptions if last fetch is less than 30 seconds ago
      if (Math.abs(diff / 1000) < 30) {
        return;
      }
    }
    // @ts-ignore
    this.lastFetch = new Date();
    try {
      this.loading$.next(true);
      const { data } = await Api.getSubscriptions();
      const slackSub = data.result.find((r:any) => r.platform === 'slack');
      if (slackSub) {
        const slackMembers = await this.getSlackMembers();
        data.result.forEach((r:any) => {
          if (r.platform === 'slack') {
            r.allMembers = slackMembers.data.result;
          }

        });
      }
      /*let once = false;
      data.result.forEach((r:any) => {
        // TODO remove this after testing
        // mocking teams result as if its indexing
        if (r.teams && !once) {
          r.teams_data_status = 'in-progress';
          once = true;
        }
      });*/
      const indexingAccounts = data.result.filter((r:any) => {
        return r.platform === 'office-365' && r.teams && r.teams_data_status === 'in-progress'
      });
      if (indexingAccounts.length) {
        this.pollIndexStatus(indexingAccounts);
      } else if (this.pollInterval) {
        clearInterval(this.pollInterval);
        SubscriptionsStore.pollInterval = null;
      }
      this.current$.next(data.result);
      this.loading$.next(false);
    } catch (err) {
      this.error$.next({
        fetch: err,
      });
      this.loading$.next(false);
    }
  },
  async pollIndexStatus(subs:Array<any>) {
    subs.forEach((sub) => {
      const intervalFn = async () => {
        try {
          const indexStatus = await Api.checkIndexStatus(sub.email);
          const { status } = indexStatus.data;
          this.updateSubStatus(sub, status);
          return status === 'ok';
        } catch (err) {
          console.log(err);
          this.updateSubStatus(sub, 'ok');
          return true;
        }
      }
      this.createPollInterval(intervalFn);
    });
  },
  createPollInterval(fn:Function, timer:number = 10000) {
    if (SubscriptionsStore.pollInterval) {
      clearInterval(SubscriptionsStore.pollInterval);
      SubscriptionsStore.pollInterval = null;
    }
    SubscriptionsStore.pollInterval = setInterval(async () => {
      const res = await fn();
      if (res) {
        clearInterval(SubscriptionsStore.pollInterval);
        SubscriptionsStore.pollInterval = null;
      }
    }, timer);
  },
  updateSubStatus(sub:object, status: string) {
    const currentSubs = this.current$.getValue();
    const newSubs = currentSubs.map((currentSub:any) => {
      if (isEqual(currentSub, sub)) {
        if (currentSub.teams_data_status !== status) {
          NotificationsStore.addNotification(currentSub, status === 'ok' ? 'index-finish' : 'indexing');
          return {
            ...currentSub,
            teams_data_status: status,
          }
        }
      }
      return currentSub;
    });
    if (!isEqual(currentSubs, newSubs)) {
      this.current$.next(newSubs);
    }
  },
  async getConnectionLinks() {
    try {
      const { data } = await Api.getConnectionLinks();
      this.connectionLinks$.next(data);
    } catch (err) {
      this.error$.next({
        connectionLinks: err,
      })
    }
  },
  async getSlackMembers() {
    try {
      const members:any = await Api.getSlackMembers();
      return members;
    } catch (err) {
      console.log(err);
      return [];
    }
  },
  async disconnectAccount(data:any) {
    try {
      await Api.disconnectAccount(data);
      await this.getUserSubscriptions(true);
    } catch (err) {
      console.log(err);
      this.error$.next({
        disconnect: err,
      });
    }
  }
}

SubscriptionsStore.current$.subscribe({
  next: (value) => {
    const normalized = normalizeSubscriptions(value || []);
    SubscriptionsStore.normalized$.next(normalized);
    NotificationsStore.createNotifications(normalized);
    SubscriptionsStore.querySubscriptions$.next(getQuerySubscriptions(normalized));
  }
})

export default SubscriptionsStore;